import type { IconSvgObject } from './types';

const Bookmark03Icon: IconSvgObject = [
  ["rect", { x: "3", y: "2.5", width: "18", height: "19", rx: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 2.5V10.5L14 8.5L17 10.5V2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Bookmark03Icon;
